import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $wrapNodeInElement } from '@lexical/utils';
import type { LexicalCommand } from 'lexical';
import { $createParagraphNode, $insertNodes, $isRootOrShadowRoot, COMMAND_PRIORITY_EDITOR, createCommand } from 'lexical';
type CommandPayload = {
  equation: string;
  inline: boolean;
};
import { $createEquationNode, EquationNode } from '../../nodes/EquationNode';
export const INSERT_EQUATION_COMMAND: LexicalCommand<CommandPayload> = createCommand('INSERT_EQUATION_COMMAND');
const EquationsPlugin = () => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (!editor.hasNodes([EquationNode])) {
      console.error('EquationsPlugins: EquationNode not registered in the editor');
      return;
    }
    return editor.registerCommand<CommandPayload>(INSERT_EQUATION_COMMAND, payload => {
      const {
        equation,
        inline
      } = payload;
      const equationNode = $createEquationNode(equation, inline);
      $insertNodes([equationNode]);
      if ($isRootOrShadowRoot(equationNode.getParentOrThrow())) {
        $wrapNodeInElement(equationNode, $createParagraphNode).selectEnd();
      }
      return true;
    }, COMMAND_PRIORITY_EDITOR);
  }, [editor]);
  return null;
};
export default EquationsPlugin;